import { useMemo } from "react";
import { IMarketFeedResponse } from "@finbackoffice/clientbff-client";
import { TemplateIdsMap, TemplateIdsMapBC } from "@finbackoffice/fe-core";

const BR_FEED_TOTAL_MARKET_IDS = [
    TemplateIdsMap.TOTAL,
    TemplateIdsMap.TOTAL_INCL_EXTRA_INNINGS,
    TemplateIdsMap.TOTAL_GAMES,
    TemplateIdsMap.TOTAL_POINTS,
    TemplateIdsMap.TOTAL_INCL_OVERTIME,
];

const BC_FEED_TOTAL_MARKET_IDS = [
    TemplateIdsMapBC.SOCCER_TOTAL,
    TemplateIdsMapBC.BASKETBALL_TOTAL,
    TemplateIdsMapBC.BASKETBALL_3X3_TOTAL,
    TemplateIdsMapBC.BASEBALL_TOTAL,
    TemplateIdsMapBC.TENNIS_TOTAL,
    TemplateIdsMapBC.HANDBALL_TOTAL,
    TemplateIdsMapBC.ICE_HOCKEY_TOTAL,
    TemplateIdsMapBC.FLOORBALL_TOTAL,
    TemplateIdsMapBC.BOXING_TOTAL,
    TemplateIdsMapBC.RUGBY_LEAGUE_TOTAL,
    TemplateIdsMapBC.RUGBY_UNION_TOTAL,
    TemplateIdsMapBC.RUGBY_SEVENS_TOTAL,
    TemplateIdsMapBC.AUSSIE_RULES_TOTAL,
    TemplateIdsMapBC.BANDY_TOTAL,
    TemplateIdsMapBC.AMERICAN_FOOTBALL_TOTAL,
    TemplateIdsMapBC.SNOOKER_TOTAL,
    TemplateIdsMapBC.TABLE_TENNIS_TOTAL,
    TemplateIdsMapBC.DARTS_TOTAL,
    TemplateIdsMapBC.VOLLEYBALL_TOTAL,
    TemplateIdsMapBC.FUTSAL_TOTAL,
    TemplateIdsMapBC.BADMINTON_TOTAL,
    TemplateIdsMapBC.MMA_TOTAL,
    TemplateIdsMapBC.BEACH_SOCCER_TOTAL,
    TemplateIdsMapBC.CRICKET_DRAW_NO_BET_TOTAL,
    TemplateIdsMapBC.COUNTER_STRIKE_TOTAL,
    TemplateIdsMapBC.DOTA_2_TOTAL,
    TemplateIdsMapBC.LEAGUE_OF_LEGENDS_TOTAL,
    TemplateIdsMapBC.OVERWATCH_TOTAL,
    TemplateIdsMapBC.VALORANT_TOTAL,
    TemplateIdsMapBC.MOBILE_LEGENDS_TOTAL,
    TemplateIdsMapBC.KING_OF_GLORY_TOTAL,
    TemplateIdsMapBC.CROSSFIRE_TOTAL,
];

const BR_FEED_HANDICAP_MARKET_IDS = [
    TemplateIdsMap.HANDICAP,
    TemplateIdsMap.HANDICAP_INCL_EXTRA_INNINGS,
    TemplateIdsMap.GAME_HANDICAP,
    TemplateIdsMap.POINT_HANDICAP,
    TemplateIdsMap.HANDICAP_INCL_OVERTIME,
];

const BC_FEED_HANDICAP_MARKET_IDS = [
    TemplateIdsMapBC.SOCCER_HANDICAP,
    TemplateIdsMapBC.BASKETBALL_HANDICAP,
    TemplateIdsMapBC.BASKETBALL_3X3_HANDICAP,
    TemplateIdsMapBC.TENNIS_HANDICAP,
    TemplateIdsMapBC.HANDBALL_HANDICAP,
    TemplateIdsMapBC.ICE_HOCKEY_HANDICAP,
    TemplateIdsMapBC.FLOORBALL_HANDICAP,
    TemplateIdsMapBC.RUGBY_LEAGUE_HANDICAP,
    TemplateIdsMapBC.RUGBY_UNION_HANDICAP,
    TemplateIdsMapBC.RUGBY_SEVENS_HANDICAP,
    TemplateIdsMapBC.AUSSIE_RULES_HANDICAP,
    TemplateIdsMapBC.BANDY_HANDICAP,
    TemplateIdsMapBC.AMERICAN_FOOTBALL_HANDICAP,
    TemplateIdsMapBC.SNOOKER_HANDICAP,
    TemplateIdsMapBC.TABLE_TENNIS_HANDICAP,
    TemplateIdsMapBC.DARTS_HANDICAP,
    TemplateIdsMapBC.VOLLEYBALL_HANDICAP,
    TemplateIdsMapBC.FUTSAL_HANDICAP,
    TemplateIdsMapBC.BADMINTON_HANDICAP,
    TemplateIdsMapBC.COUNTER_STRIKE_HANDICAP,
    TemplateIdsMapBC.DOTA_2_HANDICAP,
    TemplateIdsMapBC.LEAGUE_OF_LEGENDS_HANDICAP,
    TemplateIdsMapBC.OVERWATCH_HANDICAP,
    TemplateIdsMapBC.VALORANT_HANDICAP,
    TemplateIdsMapBC.MOBILE_LEGENDS_HANDICAP,
    TemplateIdsMapBC.KING_OF_GLORY_HANDICAP,
    TemplateIdsMapBC.CROSSFIRE_HANDICAP,
];

export const useFeaturedMarkets = (markets: IMarketFeedResponse[], isBCFeed: boolean) => {
    const totalMarkets = useMemo(
        () =>
            markets.filter((market) =>
                isBCFeed
                    ? BC_FEED_TOTAL_MARKET_IDS.includes(market.template_id)
                    : BR_FEED_TOTAL_MARKET_IDS.includes(market.template_id),
            ),
        [markets, isBCFeed],
    );

    const handicapMarkets = useMemo(
        () =>
            markets.filter((market) =>
                isBCFeed
                    ? BC_FEED_HANDICAP_MARKET_IDS.includes(market.template_id)
                    : BR_FEED_HANDICAP_MARKET_IDS.includes(market.template_id),
            ),
        [markets, isBCFeed],
    );

    const otherMarkets = useMemo(
        () =>
            markets.filter((market) =>
                [
                    TemplateIdsMap.WHICH_TEAM_WINS_THE_COIN_TOSS,
                    TemplateIdsMap.TEAM_WITH_TOP_BATTER,
                    TemplateIdsMap.TEAM_WITH_TOP_BOWLER,
                    TemplateIdsMap.MOST_SIXES,
                ].includes(market.template_id),
            ),
        [markets],
    );

    return {
        totalMarkets,
        handicapMarkets,
        otherMarkets,
    };
};
